// const url = 'http://localhost:3000/';
// const url = 'https://apibackshell.com/';

// const url = 'http://api-hse-shell.blistertechnologies.com/';

const url = 'https://api-test-blister.blistertechnologies.com.ar/';

// const url = 'https://shell-hse.blistertechnologies.com.ar/';

export const environment = {
  production: false,
  testing: true,
  // url: `${url}api/`,
  url: `${url}api/`,
  imagesUrl: `${url}api/uploads/`,
  webUrl: url,
  socket: `${url}permisos`,
};
